import type { ElementType } from 'react';
import clsx from 'clsx';

import { usePaginationContext } from './Pagination.context';

const EllipsisIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    className={className}
  >
    <path d="M3 10a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM8.5 10a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM15.5 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" />
  </svg>
);

export const PaginationDots = ({ icon }: { icon?: ElementType }) => {
  const Icon = icon || EllipsisIcon;
  const ctx = usePaginationContext();

  return (
    <div className={clsx('pagination-dots', ctx.classNames?.dots)}>
      <Icon className={clsx('pagination-icon', ctx.classNames?.icon)} />
    </div>
  );
};

PaginationDots.displayName = 'PaginationDots';
